__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@byted-meego/mf_openapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@douyinfe/semi-icons", "2.38.2", () => (Promise.all([__webpack_require__.e(8000), __webpack_require__.e(5578), __webpack_require__.e(5769), __webpack_require__.e(1013)]).then(() => (() => (__webpack_require__(48000))))));
			register("@editor-kit/core", "4.112.0-alpha-v3-email.1", () => (Promise.all([__webpack_require__.e(887), __webpack_require__.e(4651), __webpack_require__.e(9021), __webpack_require__.e(7077)]).then(() => (() => (__webpack_require__(20887))))));
			register("@editor-kit/delta", "4.112.0-alpha-v3-email.1", () => (Promise.all([__webpack_require__.e(5718), __webpack_require__.e(4651)]).then(() => (() => (__webpack_require__(85718))))));
			register("@editor-kit/utils", "4.112.0-alpha-v3-email.1", () => (__webpack_require__.e(4704).then(() => (() => (__webpack_require__(84704))))));
			register("axios", "1.4.0", () => (__webpack_require__.e(1772).then(() => (() => (__webpack_require__(61772))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(7608).then(() => (() => (__webpack_require__(87608))))));
			register("i18next", "19.9.2", () => (__webpack_require__.e(7869).then(() => (() => (__webpack_require__(7869))))));
			register("mobx-react", "6.3.1", () => (Promise.all([__webpack_require__.e(6699), __webpack_require__.e(7668)]).then(() => (() => (__webpack_require__(96699))))));
			register("mobx", "5.15.7", () => (__webpack_require__.e(2771).then(() => (() => (__webpack_require__(72771))))));
			register("moment", "2.29.4", () => (Promise.all([__webpack_require__.e(7200), __webpack_require__.e(7335)]).then(() => (() => (__webpack_require__(6901))))));
			register("query-string", "5.1.1", () => (__webpack_require__.e(6319).then(() => (() => (__webpack_require__(66319))))));
			register("query-string", "6.14.1", () => (__webpack_require__.e(1105).then(() => (() => (__webpack_require__(81105))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(5208), __webpack_require__.e(2458)]).then(() => (() => (__webpack_require__(10571))))));
			register("react-markdown", "6.0.3", () => (Promise.all([__webpack_require__.e(6340), __webpack_require__.e(4585)]).then(() => (() => (__webpack_require__(86340))))));
			register("react-query", "3.39.2", () => (Promise.all([__webpack_require__.e(1780), __webpack_require__.e(5578), __webpack_require__.e(2173), __webpack_require__.e(3050)]).then(() => (() => (__webpack_require__(11780))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(6148), __webpack_require__.e(3965), __webpack_require__.e(5521), __webpack_require__.e(7114)]).then(() => (() => (__webpack_require__(97114))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(6148), __webpack_require__.e(6172), __webpack_require__.e(3965), __webpack_require__.e(8519)]).then(() => (() => (__webpack_require__(96172))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2500).then(() => (() => (__webpack_require__(29901))))));
			initExternal(23392);
			initExternal(34539);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};